<template>
  <fragment>
    <v-subheader v-show="!editing">
      <v-btn color="grey" outlined @click.stop="editing = true">修改密码</v-btn>
    </v-subheader>
    <v-form class="px-4" v-model="valid" ref="form" v-show="editing">
      <v-text-field
        label="旧密码"
        v-model="oldPass"
        outlined
        counter="32"
        dense
        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show1 ? 'text' : 'password'"
        @click:append="show1 = !show1"
      />
      <v-text-field
        label="新密码"
        v-model="newPass"
        outlined
        counter="32"
        dense
        :rules="Object.values(rules)"
        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show2 ? 'text' : 'password'"
        @click:append="show2 = !show2"
      />
      <v-btn class="mr-2" color="primary" elevation="0" @click.stop="save">保存</v-btn>
      <v-btn class="ml-2" color="grey" outlined @click.stop="editing = false">取消</v-btn>
    </v-form>
  </fragment>
</template>

<script>
export default {
  name: 'ChangePass',
  data () {
    return {
      valid: true,
      editing: false,
      oldPass: '',
      newPass: '',
      show1: false,
      show2: false,
      rules: {
        required: v => !!v || '密码不能为空',
        min: v => v.length >= 12 || '密码至少12个字符',
        lowerCase: v => /.*[a-z].*/.test(v) || '至少包含一个小写字母',
        upperCase: v => /.*[A-Z].*/.test(v) || '至少包含一个大写字母',
        symbol: v => /.*[[\]!@#$%^&*()_+\-=`~;:'"{},.<>/?|\\].*/.test(v) || '至少包含一个符号'
      }
    }
  },
  watch: {
    editing (newVal) {
      if (newVal === true) {
        this.oldPass = ''
        this.newPass = ''
        this.$refs.form.resetValidation()
      }
    }
  },
  methods: {
    save () {
      this.$refs.form.validate()
      if (this.valid) {
        this.$emit('save', {
          newPass: this.newPass,
          oldPass: this.oldPass
        })
        this.editing = false
      }
    }
  }
}
</script>
